import bwv846System0 from '@Assets/demo/bwv846/system_0.png';
import bwv846System1 from '@Assets/demo/bwv846/system_1.png';
import bwv846System2 from '@Assets/demo/bwv846/system_2.png';
import chopinOp9n2System0 from '@Assets/demo/chopin-op9n2/system_0.png';
import chopinOp9n2System1 from '@Assets/demo/chopin-op9n2/system_1.png';
import chopinOp9n2System2 from '@Assets/demo/chopin-op9n2/system_2.png';

import { SAMPLE_CARDS } from './sampleCards';
import { getSamplePageMeta } from '../seo/publicPageMeta';

/** Frozen score served at `/sample/:slug`. See `src/assets/demo/<id>/README.md`. */
export interface SampleProject {
  slug: string;
  title: string;
  cardTitle: string;
  composer: string;
  pageSrcs: string[];
  fingeringUrl: string;
  /** Point-in-time export; does not include visitor edits. PDF export does. */
  xmlUrl: string;
  xmlSibeliusUrl: string;
  downloadBaseName: string;
}

export const SAMPLE_PROJECTS: SampleProject[] = [
  {
    slug: 'bach-prelude-in-c-major-bwv-846',
    title: 'Prelude in C major, BWV 846',
    cardTitle: 'Prelude in C major',
    composer: 'J. S. Bach',
    pageSrcs: [bwv846System0, bwv846System1, bwv846System2],
    fingeringUrl: '/demo/bwv846/fingering.json',
    xmlUrl: '/demo/bwv846/bwv846_fingering.xml',
    xmlSibeliusUrl: '/demo/bwv846/bwv846_fingering_sibelius.xml',
    downloadBaseName: 'bach-prelude-in-c-major-bwv-846',
  },
  {
    slug: 'chopin-nocturne-op-9-no-2',
    title: 'Nocturne in E-flat major, Op. 9 No. 2',
    cardTitle: 'Nocturne Op. 9 No. 2',
    composer: 'F. Chopin',
    pageSrcs: [chopinOp9n2System0, chopinOp9n2System1, chopinOp9n2System2],
    fingeringUrl: '/demo/chopin-op9n2/fingering.json',
    xmlUrl: '/demo/chopin-op9n2/chopin_op9n2_fingering.xml',
    xmlSibeliusUrl: '/demo/chopin-op9n2/chopin_op9n2_fingering_sibelius.xml',
    downloadBaseName: 'chopin-nocturne-op-9-no-2',
  },
];

export const getSampleProject = (
  slug: string | undefined
): SampleProject | undefined =>
  slug ? SAMPLE_PROJECTS.find((sample) => sample.slug === slug) : undefined;

const cardSlugs = new Set(SAMPLE_CARDS.map((card) => card.slug));
for (const sample of SAMPLE_PROJECTS) {
  if (!cardSlugs.has(sample.slug)) {
    throw new Error(`sampleCards.ts is missing slug "${sample.slug}"`);
  }
  if (!getSamplePageMeta(sample.slug)) {
    throw new Error(`publicPageMeta.json is missing /sample/${sample.slug}`);
  }
}
